import { ApiConfig } from '@configs';

// Defaults to "" in environments
const baseURL = ApiConfig.url;

export const endpoints = {
	accountChallengeCertificate: `${ApiConfig.certificateUrl}/account/challenge/fe`,
	accountChallenge: `${baseURL}/account/challenge`,
	accountGenerateCaptcha: `${baseURL}/account/generateCaptcha`,
	accountLogin: `${baseURL}/account/login`,
	accountSafe: `${baseURL}/account/safe`,
	accountUser: `${baseURL}/account/user`,
	accountUserCredentials: `${baseURL}/account/userCredentials`,
	accountDeleteCookies: `${baseURL}/account/deleteCookies`,
	accountCmdUrl: `${baseURL}/account/cmdUrl`,
	accountCmdAuthentication: `${baseURL}/account/cmdAuthentication`,
	analyticsPSD2: `${baseURL}/analytics/psd2`,
	contentsClient: `${baseURL}/contents/client`,
	contentsClientCookies: `${baseURL}/contents/client/cookies`,
};
